'use client';

import { useEffect } from 'react';
import { trimGID } from '@app/lib/shopify/helpers/gid';

interface CollectionNostoTrackingProps {
    collectionId: string;
    collectionHandle: string;
    products: any[];
    term?: string;
}

const CollectionNostoTracking = ({
    collectionId,
    collectionHandle,
    products,
    term,
}: CollectionNostoTrackingProps) => {
    // Track search results
    useEffect(() => {
        if (term) {
            typeof window !== 'undefined' &&
                typeof (window as any).nostojs === 'function' &&
                (window as any).nostojs((api) => {
                    api.defaultSession()
                        .recordSearch(
                            "serp",
                            {
                                query: term
                            },
                            {
                                products: {
                                    hits: products.map((product) => ({
                                        productId: trimGID(product.id)
                                    })),
                                    fuzzy: true,
                                    total: products.length,
                                    size: products.length,
                                    from: 0
                                }
                            }
                        )
                        .done();
                });
        }
    }, [term, products]);

    // Track collection view
    useEffect(() => {
        if (collectionHandle && collectionId) {
            typeof window !== 'undefined' &&
                typeof (window as any).nostojs === 'function' &&
                (window as any).nostojs((api) => {
                    api.defaultSession()
                        .recordSearch(
                            "category",
                            {
                                products: {
                                    categoryId: trimGID(collectionId),
                                    categoryPath: `/collections/${collectionHandle}`,
                                    size: products.length,
                                    from: 0
                                }
                            },
                            {
                                products: {
                                    categoryId: trimGID(collectionId),
                                    categoryPath: `/collections/${collectionHandle}`,
                                    hits: products.map((product) => ({
                                        productId: trimGID(product.id)
                                    })),
                                    fuzzy: true,
                                    total: products.length,
                                    size: products.length,
                                    from: 0
                                }
                            }
                        )
                        .done();
                });
        }
    }, [collectionHandle, collectionId, products]);

    return null;
};

export default CollectionNostoTracking;
